interface EyeClosedSvgProps {
  className?: string;
}

export function EyeClosedSvg({ className }: EyeClosedSvgProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      className={className}
    >
      <path
        d="M4.52 5.936 1.394 2.809l1.414-1.414 19.799 19.799-1.414 1.414-3.31-3.31A10.949 10.949 0 0 1 12 21c-5.392 0-9.878-3.88-10.818-9A10.982 10.982 0 0 1 4.52 5.936Zm10.238 10.237-1.464-1.464a3 3 0 0 1-4.001-4.001L7.829 9.244a5 5 0 0 0 6.929 6.929ZM7.974 3.76c1.247-.49 2.605-.76 4.026-.76 5.392 0 9.878 3.88 10.819 9a10.947 10.947 0 0 1-2.012 4.592l-3.86-3.86a5 5 0 0 0-5.68-5.68L7.975 3.762Z"
        fill="currentColor"
      />
    </svg>
  );
}
